import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {RichTextEditor} from '../../../../../../../../../components/RichTextEditor/RichTextEditor';

interface Props {
  formik: any;
}

export const AboutTheJobFieldsResponsibilities = ({formik}: Props) => {
  const {t} = useTranslation();
  const onChange = (text: string) => {
    formik.setFieldValue('responsibilities', text);
  };

  return (
    <>
      <Box sx={{mb: 5}}>
        <Typography variant='h4' gutterBottom component='div'>
          {t('companyJobPostings.newJobDialog.formLabels.responsibilities')}*
        </Typography>
        <RichTextEditor
          isEditable={true}
          readText={onChange}
          defaultText={formik.initialValues.responsibilities}
          fontSize='20px'
        />

        <Typography variant='body2' color='error'>
          <ErrorMessage name='responsibilities' component='span' />
        </Typography>
      </Box>
    </>
  );
};
